import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiResponseModel, ApiVisa, BaseApiTemplateService} from '../../shared';
import {Core2Config} from '../../shared';
import {
  ClaimEntitlementAutoTopUpRunCompanyFilterContainerModel
} from '../../../../../../models';
import {Observable} from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class ClaimEntitlementAutoTopUpRunCompanyFilterService extends BaseApiTemplateService<ClaimEntitlementAutoTopUpRunCompanyFilterContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX +
    Core2Config.AAT_PREFIX + Core2Config.CLAIMS_PREFIX + 'accounts/entitlements/auto-top-up-runs/filter-companies/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX +
      Core2Config.AAT_PREFIX + Core2Config.CLAIMS_PREFIX + 'accounts/entitlements/auto-top-up-runs/filter-companies/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'accounts/entitlements/auto-top-up-runs/filter-companies/backoffice-ep';
    this.httpClient = http;
  }

  postMultipleFilter(body: ClaimEntitlementAutoTopUpRunCompanyFilterContainerModel[], visa: ApiVisa):
    Observable<ApiResponseModel<ClaimEntitlementAutoTopUpRunCompanyFilterContainerModel>>  {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'accounts/entitlements/auto-top-up-runs/filter-companies/multiple/backoffice-ep';
    if (visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
        Core2Config.CLAIMS_PREFIX + 'accounts/entitlements/auto-top-up-runs/filter-companies/multiple/backoffice-ep';
    }

    return this.httpClient.post<ApiResponseModel<ClaimEntitlementAutoTopUpRunCompanyFilterContainerModel>>(
      url,
      body,
      this.getHttpHeader(visa)
    );
  }

}


